import React from "react"
import PropTypes from "prop-types"
import { OutboundLink } from "gatsby-plugin-google-analytics"

const SubheaderCovid = () => (
  <div className="covid-block">
    <div className="covid-block__text t6">
      Learn what we are doing in response to coronavirus.  <OutboundLink href="/covid-response" className="fw7"> Learn more</OutboundLink>
    </div>
  </div>
)



export default SubheaderCovid
{/* <OutboundLink href="/covid-response" className="subheader__cta cta cta--tiny t5"> </OutboundLink> */}
